<template>
    <div class="row mt-2 mb-2 justify-content-md-center justfiy-content-left">
        <div class="col">
            <submission-card
                :id="id"
                :text="text"
                :status="status"
                :image_url="image_url"
                :submission_time="submission_time"
                :decision_time="decision_time"
                :scheduled_post_time="scheduled_post_time"
                :hit_filter="hit_filter ? true : false"
                :route_truth_details="route_truth_details"
                :numbered="numbered ? true : false"
                :header_text="header_text"
                :nsfw_probability="nsfw_probability"
                :posted_time="posted_time"
                :post_link="post_link"
                :filter_phrases="filter_phrases"
                :instagram="instagram"
            ></submission-card>
        </div>
    </div>
</template>


<script>
import SubmissionCard from '../submissions/SubmissionCard'

export default {
  name: "ArchiveListItem",

    components: {
        SubmissionCard,
    },

    props: {
        id: {
            type: Number,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
        image_url: {
            type: String,
        },
        submission_time : {
            type: String,
            required: true,
        },
        decision_time : {
            type: String,
        },
        scheduled_post_time : {
            type: String,
        },
        hit_filter:  {
            type: Boolean,
            required: true,
        },
        route_truth_details: {
            type: String,
            required: true,
        },
        numbered: {
            type: Boolean,
            required: true
        },
        header_text: {
            type: String,
        },
        nsfw_probability: {
            type: Number
        },
        posted_time: {
            type: String
        },
        post_link: {
            type: String
        },
        filter_phrases: {
            type: Array
        },
        instagram: {
            type: Boolean
        }
    }
}
</script>